/**
 * Created by Vladislav on 07.03.2025.
 */

Placements.ENTRIES["weeklyCupReward"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,
    filter: function () {
        return cleverapps.weeklyCup.getReward();
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "weeklyCupReward",
            action: function (f) {
                cleverapps.weeklyCup.receiveReward(f);
            }
        });
    }
};